
<!-- 首页架子 -->
<template>
  <div>
    <!-- 头部导航 -->
    <el-container>
      <!-- 设置头部信息 -->
      <el-header>
        <!-- 页面头部内容,没有登录时展示, 未登录展示 -->
        <span v-if="loginFlag">
          <span class="span1">
            <router-link to="/loginPage" class="a1">注册</router-link>
          </span>
          <span class="span1">
            <router-link to="/loginPage" class="a1">登录</router-link>
          </span>
        </span>

        <!-- 登录后展示 -->
        <span v-else>
          <!-- 设置头像，和头像的下拉菜单 -->
          <span class="span1">
            <el-dropdown trigger="click">
              <!-- 设置头像 -->
              <div type="primary">
                <el-avatar :src="headerSculpture"></el-avatar>
              </div>

              <!-- 设置头像的下拉菜单 -->
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item> 积分：{{ price }}</el-dropdown-item>
                <el-dropdown-item>
                  <!-- 使用router-link标签来替换a标签，实现路由的跳转 -->
                  <router-link to="/userIndex" class="a1">个人信息</router-link>
                </el-dropdown-item>
                <!-- <el-dropdown-item>
                  <router-link to="/editUserPw" class="a1"
                    >修改密码</router-link
                  >
                </el-dropdown-item> -->
                <el-dropdown-item>
                  <span @click="logout()">退出登录</span>
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </span>

          <!-- 消息 -->
          <span class="span1">
            <el-badge class="item" :value="num">
              <el-button size="small" @click="toMessage">消息</el-button>
            </el-badge>
          </span>

          <!-- 发布 -->
          <span class="span1">
            <!-- <el-button size="small" @click="toMessage">发布</el-button> -->
            <el-dropdown
              size="small"
              split-button
              type="primary"
              @command="handleCommand"
            >
              发布
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item command="writeQuestion"
                  >写面试题/文章</el-dropdown-item
                >
                <el-dropdown-item command="writeProject" v-if="roleType==='admin'"
                  >发布项目</el-dropdown-item
                >
                <el-dropdown-item command="resourceDownload"
                  >传资源</el-dropdown-item
                >
              </el-dropdown-menu>
            </el-dropdown>
          </span>
        </span>

        <!-- logo和标题 -->
        <span id="spanImg">
          <img
            id="img1"
            src="https://cms-headsculpture-1317095913.cos.ap-beijing.myqcloud.com/logo/logo.png"
            alt=""
          />
          <span id="title">AI Knowledge Base</span>
        </span>

        <!-- 导航头下拉菜单 -->
        <span>
          <el-menu
            :default-active="activeIndex"
            class="el-menu-demo"
            mode="horizontal"
            @select="handleSelect"
          >
            <el-menu-item index="1" @click="goHome">首页</el-menu-item>
            <el-menu-item index="2" @click="goQuestionBank"
              >题库/文章</el-menu-item
            >
            <!-- <el-menu-item index="3" @click="goExperience"
              >精品文章</el-menu-item
            > -->
            <el-menu-item index="4" @click="goDelicacyProject"
              >精品项目</el-menu-item
            >
            <el-menu-item index="5" @click="goResourceDownload"
              >资源下载</el-menu-item
            >
            <el-menu-item index="6" @click="goAIHelper">AI助手</el-menu-item>
          </el-menu>
        </span>
      </el-header>

      <!-- 中间内容 -->
      <el-main>
        <router-view></router-view>
      </el-main>

      <!-- 底部导航 -->
      <el-footer>
        <span id="footer">
          2024 My Website. All rights reserved.<br />
          Contact: kelizhadan@gmail.com
          <a href="https://beian.miit.gov.cn/" target="_blank" style="text-decoration: none;">冀ICP备2024094674号-1</a>
        </span>
      </el-footer>
    </el-container>
  </div>
</template>

<script>
import { mapState, mapMutations } from "vuex";
export default {
  name: "homeIndex",
  data() {
    return {
      // 下拉菜单中的选中标识
      activeIndex: "1",
      // 判断登录状态
      loginFlag: true,
      // 消息的数据
      num: 0,
      // 用户下拉列表中的余额
      price: 0,

      // 设置头像信息，从前端缓存获取
      headerSculpture: "",
      // 登录用户的信息
      strLoginUserData: "",
      // 登录用户的信息，对象
      loginUserData: {},
      // 当前登录用户的权限：管理员/普通用户
      roleType:""
    };
  },
  // 已进入页面开始执行
  created() {
    this.activeIndex = this.homeIndexData.activeIndex;
    // 从本地缓存中获取数
    this.strLoginUserData = localStorage.getItem("accessUserData");
    this.loginUserData = JSON.parse(this.strLoginUserData);

    console.log("获取本地缓存的数据为：" + this.loginUserData);
    if (!(this.loginUserData === "" || this.loginUserData === null)) {
      // 证明已经登录
      this.loginFlag = false;
      // 获取缓存中price余额的值
      this.price = this.loginUserData.data.pricePo.price;
      // 获取头像地址
      this.headerSculpture = this.loginUserData.data.headsculpture;
      // 获取当前用户权限
      this.roleType=this.loginUserData.data.roleType;
    }
  },

  // 计算属性
  computed: {
    ...mapState(["homeIndexData"]),
  },

  methods: {
    // 新增面试题
    handleCommand(command) {
      if (command === "writeQuestion") {
        // 写面试题
        console.log("写面试题");
        // 跳转到添加面试题页面
        const targetRoute = "/questionBankAdd";
        if (this.$route.path !== targetRoute) {
          this.$router.push("/questionBankAdd");
        }
      } else if (command === "writeProject") {
        // 发布项目
        console.log("发布项目");
        this.$router.push("/delicacyProject/delicacyProjectAdd");
      } else if (command === "resourceDownload") {
        // 上传资源
        console.log("上传资源");
        this.$router.push("/resourceDownloadAdd");
      }
    },

    // 跳转到消息页面
    toMessage() {
      const targetRoute = "/userIndex/message";
      if (this.$route.path !== targetRoute) {
        this.$router.push("/userIndex/message");
      }
    },

    // 选择下拉方法
    handleSelect(key, keyPath) {
      console.log(key, keyPath);
    },
    //   点击菜单方法-首页
    goHome() {
      console.log("首页");
      // 跳转到首页
      const targetRoute = "/home";
      if (this.$route.path !== targetRoute) {
        this.$router.push(targetRoute);
      }
    },
    //   点击菜单方法-面试题库
    goQuestionBank() {
      console.log("面试题库");
      // 跳转
      const targetRoute = "/questionBank";
      if (this.$route.path !== targetRoute) {
        this.$router.push(targetRoute);
      }
    },
    //   点击菜单方法-经验积累
    goExperience() {
      console.log("经验积累");
      const targetRoute = "/experience";
      if (this.$route.path !== targetRoute) {
        this.$router.push(targetRoute);
      }
    },
    // 点击菜单方法-AI助手
    goAIHelper() {
      console.log("AI助手");
      const targetRoute = "/aiHelper";
      if (this.$route.path !== targetRoute) {
        this.$router.push(targetRoute);
      }
    },
    // 点击菜单方法-精品项目
    goDelicacyProject() {
      console.log("精品项目");
      const targetRoute = "/delicacyProject";
      if (this.$route.path !== targetRoute) {
        this.$router.push(targetRoute);
      }
    },

    // 点击菜单方法-资源下载
    goResourceDownload() {
      const targetRoute = "/resourceDownload";
      if (this.$route.path !== targetRoute) {
        this.$router.push(targetRoute);
      }
    },

    // 退出登录方法
    logout() {
      try {
        console.log("进入到退出登录方法中");

        // 清除本地存储中的用户信息和令牌
        localStorage.removeItem("accessUserData");

        // 重定向到登录页面,捕获错误并忽略它
        this.$router.push("/").catch((err) => {
          if (err.name !== "NavigationDuplicated") {
            throw err;
          }
        });
        // 刷新页面
        window.location.reload();

        // 显示退出成功的消息提示（可选）
        this.$message.success("退出登录成功");
      } catch (error) {
        // 退出登录失败时
        console.error("Logout failed:", error);
        this.$message.error("退出登录失败，请重试");
      }
    },
  },
};
</script>



<style lang="less" scoped>
// 发布按钮样式
// .el-dropdown {
//     vertical-align: top;
//   }
//   .el-dropdown + .el-dropdown {
//     margin-left: 15px;
//   }
//   .el-icon-arrow-down {
//     font-size: 12px;
//   }

// footer底部样式

.el-header {
  text-align: center;
  line-height: 60px;
}

.el-main {
  background-color: #e9eef3;
  color: #333;
  // text-align: center;
}
// 设置头部导航
.span1 {
  float: right;
  margin-left: 10px;
}
// 鼠标放上去显示
.span1:hover {
  transition: all 0.5s;
}
.a1 {
  text-decoration: none;
  color: #0e0d0d;
}
// 设置logo
#img1 {
  width: 40px;
  height: 40px;
}
#spanImg {
  float: left;
}

// 标题标签样式
#title {
  flex: 1;
  color: #355476;
  margin-left: 10px;
  font-size: 20px;
  font-weight: 700;
}

// 底部区域
.el-footer {
  background-color: hsl(220, 14%, 96%);
  color: #333;
  text-align: center;
  line-height: 30px;
}

// 设置导航中间菜单
.el-menu-demo {
  width: 600px;
  margin-left: 400px;
  height: 60px;
}

// 设置头像
.el-avatar {
  margin-top: 10px;
}

// 设置头像的外围框
.el-dropdown-selfdefine {
  height: 55px;
}

// 设置消息样式
.el-badge {
  margin-right: 20px;
}
</style>
